
import innerHeight from 'ios-inner-height';

export default function viewportHeight() {

    let navPanelHeight = innerHeight() - window.innerHeight;

    console.log('Nav panel height', navPanelHeight)
    function appHeight() {

        console.log('Inner height', innerHeight())

        
        
        document.documentElement.style.setProperty('--vh', (innerHeight() - navPanelHeight) * 0.01 + 'px');
    }

    appHeight();

   
    
    window.addEventListener('resize', appHeight);




    


    
}